<template>
  <div class="cms-form-group" :class="{ 'cms-form-group-full': fullWidth }">
    <label v-if="label" :for="textareaId">{{ label }}</label>
    <textarea
      :id="textareaId"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :rows="rows"
      :maxlength="maxLength ?? undefined"
      class="cms-textarea"
      @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    ></textarea>
    <div v-if="showCounter && typeof maxLength === 'number'" class="cms-textarea-meta">
      <span class="cms-textarea-counter" :class="{ 'is-over': counterValue > maxLength }">
        {{ counterValue }}/{{ maxLength }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
  modelValue: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  helpText?: string;
  rows?: number;
  maxLength?: number;
  showCounter?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: '',
  disabled: false,
  required: false,
  fullWidth: false,
  rows: 3,
  showCounter: false
});

defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const textareaId = computed(() => `cms-textarea-${Math.random().toString(36).substr(2, 9)}`);

const counterValue = computed(() => (props.modelValue ?? '').length);
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-textarea-meta {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.25rem;
}

.cms-textarea-counter {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);

  &.is-over {
    color: #d32f2f;
    font-weight: 600;
  }
}
</style>



